import { useSoyuzExperiment } from '@spotahome/soyuz/client';

import useAutocompleteServiceMapbox from './useAutocompleteService.mapbox';
import useAutocompleteServiceGoogle from './useAutocompleteService.google';
import useAutocompleteServiceWoosmap from './useAutocompleteService.woosmap';

// Dispatcher for the MapProvider experiment. The bucket is session-scoped, so
// the chosen branch is stable across renders of any given component instance —
// the rules-of-hooks rule is satisfied in practice, even though the lint can't
// prove it statically.
const useAutocompleteService = props => {
  const mapProviderVariant = useSoyuzExperiment('MapProvider').get('behaviour');

  if (mapProviderVariant === 'mapbox') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useAutocompleteServiceMapbox(props);
  }

  if (mapProviderVariant === 'woosmap') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useAutocompleteServiceWoosmap(props);
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useAutocompleteServiceGoogle(props);
};

export default useAutocompleteService;
